<template>
	<ol class="l-timeline" data-testid="timeline">
		<li v-for="event in events" :key="event.key" class="l-timeline-item">
			<span class="l-timeline-dot" :class="'tone-' + toneOf(event)" aria-hidden="true"></span>

			<div class="l-timeline-body">
				<div class="l-timeline-title">{{ event.title }}</div>
				<div v-if="event.meta" class="l-timeline-meta">{{ event.meta }}</div>
				<div v-if="event.detail" class="l-timeline-detail">{{ event.detail }}</div>
			</div>
		</li>
	</ol>
</template>










<script setup>
/**
 * §8.6 Timeline: a vertical list of things that happened, oldest at the top, each with a dot
 * (tinted by `tone`), a line joining it to the next, a title, who/when, and optional detail.
 *
 * Use it for a change history ("Captured", "Reallocated by Dominic", ...). For a flat audit row
 * with a from → to status change, use LAuditTrailRow.
 *
 * `events` is `[{ key, title, meta, detail, tone }]`; `tone` is neutral (default) | pending |
 * success | danger. The caller supplies the finished text: this component formats nothing.
 */

//-- Props
defineProps({
	events: {
		type: Array,
		required: true,
	},
});





//-- Methods
const toneOf = (event) => event.tone || 'neutral';
</script>










<style scoped>
.l-timeline
{
	list-style: none;
	margin: 0;
	padding: 0;
}

.l-timeline-item
{
	position: relative;
	display: flex;
	gap: var(--sp-3);
	padding: 0 0 var(--sp-4) 0;
}

/* The line to the next event. */
.l-timeline-item:not(:last-child)::before
{
	content: '';
	position: absolute;
	left: 3px;
	top: 14px;
	bottom: 0;
	width: 1px;
	background: var(--line-strong);
}

.l-timeline-item:last-child
{
	padding-bottom: 0;
}

.l-timeline-dot
{
	flex: none;
	width: 7px;
	height: 7px;
	margin-top: 6px;
	border-radius: 50%;
	background: var(--decorative);
}

.l-timeline-dot.tone-pending { background: var(--status-pending-text); }
.l-timeline-dot.tone-success { background: var(--status-approved-text); }
.l-timeline-dot.tone-danger { background: var(--status-rejected-text); }

.l-timeline-body
{
	min-width: 0;
}

.l-timeline-title
{
	font-size: var(--text-base);
	font-weight: 600;
	color: var(--text);
}

.l-timeline-meta
{
	font-size: var(--text-chip);
	color: var(--text-3);
}

.l-timeline-detail
{
	margin-top: 2px;
	font-size: var(--text-sm);
	color: var(--text-2);
}
</style>
